(function () {
	'use strict';

	angular
		.module('dcApp')
		.directive('dashboardPages', [
			'$parse','$timeout', '$log', 'DashboardService',
			function ($parse, $timeout, $log, DashboardService) {
				var controller = [
					'$scope',
					function ($scope) {
						var vm = this;
						vm.selectedPage = null;
						vm.selectPage = selectPage;
						vm.updatePageSelectionOn = updatePageSelection;
						vm.pageElementCount = pageElementCount;
						vm.elementCount = {};

						function selectPage(pageId) {
							vm.selectedPage = pageId;
							updatePageSelection();
						}

						function pageElementCount() {
							_.each(vm.dashboardConfig.elements, function (elm) {
								if (vm.elementCount.hasOwnProperty(elm.page)) {
									vm.elementCount[elm.page] = vm.elementCount[elm.page] + 1;
								} else {
									vm.elementCount[elm.page] = 1;
								}
							});
						}

						function updatePageSelection() {
							vm.selectedPage = isEmpty(vm.selectedPage) ?  vm.dashboardConfig.global.pages[0].id : vm.selectedPage;
							let tempFilteredElements=  _.filter(vm.dashboardConfig.elements, function (elm) {
																	return elm.page === vm.selectedPage || (elm.config && elm.config.page === vm.selectedPage);
																});
							vm.dashboardConfig.filteredElements =  [];
							// load by batch
							DashboardService.elementLazyLoading(vm.dashboardConfig, tempFilteredElements);
							if (vm.dashboardConfig.global.centering_active) {
								const usedCentering = vm.dashboardConfig.filteredElements.flatMap(elm => {
									return elm.centering ? Object.keys(elm.centering) : [];
								});
								vm.dashboardConfig.global.filteredCentering =  _.filter(vm.dashboardConfig.global.centerings, function (elm) {
									return usedCentering.indexOf(elm.uuid) > -1;
								});
							}
						}
					},
				];
				return buildDirectiveReturnObject(
					{
						dashboardConfig: '=',
						selectedPage: '=',
						editMode: '=',
						openPagesManagement: '<'
					},
					controller,
					'./src/components/directives/handledata/dashboardPages/dashboard-pages.html',
					function postLink(scope, element, attrs) {
						if (scope.vm.editMode) {
							scope.vm.pageElementCount();
						}
						scope.$on("UPDATE_PAGES_SELECTION",function(event, data){
							scope.vm.updatePageSelectionOn();
						});
					}
				);
			},
		]);
})();
